var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareTicketIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon share-icon",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.882V19h-1V1.882L6.226 6 5.5 5.3 11 0l5.5 5.3-.726.7L11.5 1.882zM8 8v1H4a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-8a3 3 0 00-3-3h-4V8h4a4 4 0 014 4v8a4 4 0 01-4 4H4a4 4 0 01-4-4v-8a4 4 0 014-4h4z"
  })));
}

export default SvgShareTicketIconSv;